import { atom } from "jotai";
import type { LyricLine } from "../types/ttml";

/**
 * @description Internal clipboard for copy/pasting lyric lines in the spectrogram.
 * Stores deep-cloned lines with their original relative timings.
 */
export const clipboardLinesAtom = atom<LyricLine[]>([]);
